let sink;
/** Nothing is emitted until a host installs a sink. */
export const setLogSink = (next) => {
    sink = next;
};
export const createDebugLogger = (namespace) => ({
    debug: (category, message, data) => sink?.(namespace, 'debug', category, message, data),
    info: (category, message, data) => sink?.(namespace, 'info', category, message, data),
    warn: (category, message, data) => sink?.(namespace, 'warn', category, message, data),
    error: (category, message, data) => sink?.(namespace, 'error', category, message, data),
});
//# sourceMappingURL=logger.js.map